const uuidRegex =
  /^\{[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}\}$/;

export default function isVariableId(value: string) {
  return uuidRegex.test(value);
}
